module.exports = __webpack_public_path__ + "img/zoom.3b6326e9.svg";